import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/cookies/*.md"))

export const Route = createFileRoute("/_content/cookies/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Cookie Policy (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Cookie Policy from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/cookies/${loaderData.date}`,
      image: "https://entire.com/og/page/cookies.png",
      noindex: true,
    })
  },
  component: CookiesVersionPage,
})

function CookiesVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/cookies" version={version} versions={versions} />
}
